/* global wp_admin_ajax */

import AjaxUtils from './utils/ajax';

export default function initSearchFAQ() {
    if (document.querySelector('.js-form-search-faq')) {
        new SearchFAQ(document.querySelector('.js-form-search-faq'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class SearchFAQ {
    constructor($el) {
        this.$el = $el;
        this.$inputSearch = this.$el.querySelector('.js-search');
        this.$resultsSearch = this.$el.querySelector('.js-resultats');
        this.init();
    }

    init() {
        document.addEventListener('click', (evt) => {
            if (this.$resultsSearch.classList.contains('visible') && !this.$resultsSearch.contains(evt.target)) {
                this.$resultsSearch.classList.remove('visible');
            }
        });
        
        this.$el.addEventListener('submit', (evt) => {
            evt.preventDefault();
        });

        this.$inputSearch.addEventListener('input', (evt) => {
            const searchText = evt.target.value;
            
            // On attend le 3eme caractère pour lancer la recherche
            if (searchText.length > 2) {
                const args = new FormData(this.$el);
                args.append('action', 'search_posts');
                
                AjaxUtils.postData(wp_admin_ajax, args).then(response => {
                    if (response.success) {
                        this.$resultsSearch.classList.add('visible');
                        this.$resultsSearch.innerHTML = response.data.html;
                    }
                });
            // Si l'input est vide, on cache et vide les résultats
            } else if (searchText.length === 0) {
                this.$resultsSearch.classList.remove('visible');
                this.$resultsSearch.innerHTML = '';
            }
        });
    }
}
